import React from 'react';

interface Restaurant3DIconProps {
  size?: number;
  color?: string;
}

export const Restaurant3DIcon = ({ size = 48, color = '#FF4500' }: Restaurant3DIconProps) => {
  const darkerColor = adjustBrightness(color, -30);
  const lighterColor = adjustBrightness(color, 40);

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shadow */}
      <ellipse cx="32" cy="58" rx="14" ry="3" fill="rgba(0,0,0,0.2)" />
      {/* Plate */}
      <ellipse cx="32" cy="50" rx="18" ry="6" fill={darkerColor} />
      <ellipse cx="32" cy="49" rx="18" ry="6" fill={color} />
      <ellipse cx="32" cy="48" rx="14" ry="4.5" fill={lighterColor} opacity="0.3" />
      {/* Cloche dome */}
      <path d="M14 42 C14 26 50 26 50 42 Z" fill={color} />
      <path d="M14 42 C14 26 50 26 50 42 Z" fill="white" opacity="0.1" />
      {/* Cloche right side darker */}
      <path d="M32 26 C42 26 50 32 50 42 L32 42 Z" fill={darkerColor} opacity="0.3" />
      {/* Cloche rim */}
      <ellipse cx="32" cy="42" rx="18" ry="4" fill={color} />
      {/* Handle */}
      <rect x="29" y="20" width="6" height="4" rx="2" fill={lighterColor} />
      <rect x="30" y="18" width="4" height="3" rx="2" fill={color} />
      {/* Shine */}
      <path d="M20 36 C20 30 28 28 28 36" stroke="white" strokeWidth="1" fill="none" opacity="0.3" />
    </svg>
  );
};

function adjustBrightness(hex: string, amount: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.min(255, Math.max(0, (num >> 16) + amount));
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00FF) + amount));
  const b = Math.min(255, Math.max(0, (num & 0x0000FF) + amount));
  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}
